import { useSnapshot } from "valtio";
import { useTreeViewDocumentPickerContext } from "../controllers/TreeViewDocumentPickerContext";
import { useMemo } from "react";
import { cn } from "@mabi-ui/utils";
import { Chip, Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";
import useEmblaCarousel from "embla-carousel-react";

export const TreeViewDocumentPickerSelectedItems = ({
	className,
	isLoading,
}: {
	className?: string;
	isLoading?: boolean;
}) => {
	const { selectedDocuments } = useTreeViewDocumentPickerContext();
	const snapshot = useSnapshot(selectedDocuments);
	const { t } = useTranslation();

	const selectedDocumentsArray = useMemo(() => {
		return Array.from(snapshot.values());
	}, [snapshot]);

	const [emblaRef] = useEmblaCarousel({
		align: "start",
		dragFree: true,
	});

	return (
		<div className={cn("overflow-hidden", className)}>
			<div ref={emblaRef} className="overflow-hidden">
				<div className="flex gap-2 items-center">
					{isLoading
						? [...Array(5)].map((_, index) => (
								<div key={index} className="flex-shrink-0 pb-2">
									<Skeleton variant="rectangular" className="w-[100px] h-6 rounded-full" />
								</div>
						  ))
						: selectedDocumentsArray.map((document) => (
								<div key={document.id} className="flex-shrink-0 pb-2">
									<Chip
										size="small"
										variant="outlined"
										color="secondary"
										label={document.name}
										onDelete={() => {
											selectedDocuments.delete(document.id);
										}}
									/>
								</div>
						  ))}
				</div>
			</div>
		</div>
	);
};
